(function(){
  var root=document.getElementById('tmrg'); if(!root) return;
  var LS_SEEN='nsc-tmr-seen', LS_RESULT='nsc-tmr-result', LS_CLAIMED='nsc-tmr-claimed';
  function lsGet(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function lsSet(k,v){try{localStorage.setItem(k,v)}catch(e){}}

  var xBtn=root.querySelector('.tmrg__x');
  if(xBtn){ xBtn.style.opacity='.32';
    xBtn.addEventListener('mouseenter',function(){xBtn.style.opacity='.75'});
    xBtn.addEventListener('mouseleave',function(){xBtn.style.opacity='.32'});
  }

  var delay=parseInt(root.dataset.delay||'5',10)*1000;
  var target=parseFloat(root.dataset.target||'6');
  var tol=parseFloat(root.dataset.tol||'0.05');
  var maxTime=parseFloat(root.dataset.max||'10');
  var winCode=root.dataset.winCode, winPct=root.dataset.winPct;
  var loseCode=root.dataset.loseCode, losePct=root.dataset.losePct;

  var display=root.querySelector('[data-tmrg-display]');
  var btn=root.querySelector('[data-tmrg-btn]');
  var btnLabel=root.querySelector('[data-tmrg-btnlabel]');
  var raf=null, t0=0, running=false, done=false;

  function fmt(sec){
    var s=Math.floor(sec), cs=Math.floor((sec-s)*100);
    return ('0'+s).slice(-2)+':'+('0'+cs).slice(-2);
  }
  function finish(elapsed, timedOut){
    running=false; done=true;
    if(raf) cancelAnimationFrame(raf);
    if(elapsed>maxTime) elapsed=maxTime;
    display.textContent=fmt(elapsed);
    showResult(elapsed, timedOut);
  }
  function tick(){
    if(!running) return;
    var el=(performance.now()-t0)/1000;
    if(el>=maxTime){ finish(maxTime, true); return; }
    display.textContent=fmt(el);
    raf=requestAnimationFrame(tick);
  }
  function stage(name){
    root.querySelectorAll('[data-tmrg-stage]').forEach(function(el){
      el.hidden = el.getAttribute('data-tmrg-stage')!==name;
    });
  }
  function paintResult(won, t, timedOut){
    root.querySelector('[data-tmrg-verdict]').textContent = won ? 'Bang on.' : (timedOut ? "Time's up." : 'So close.');
    root.querySelector('[data-tmrg-time]').textContent = timedOut ? 'The clock ran out at '+fmt(maxTime) : ('You stopped at ' + t + 's');
    root.querySelector('[data-tmrg-prize]').textContent = (won?winPct:losePct) + '% OFF';
    var codeEl=root.querySelector('[data-tmrg-code]');
    if(codeEl) codeEl.textContent = won?winCode:loseCode;
    var sub=root.querySelector('[data-tmrg-sub]');
    if(sub) sub.textContent = won
      ? 'Perfect timing. Enter your details to claim it.'
      : 'Not exact — but you still walk away with something. Enter your details to claim it.';
  }
  function showResult(elapsed, timedOut){
    var won=Math.abs(elapsed-target)<=tol;
    lsSet(LS_RESULT, JSON.stringify({won:won, t:elapsed.toFixed(2), to:!!timedOut}));
    paintResult(won, elapsed.toFixed(2), timedOut);
    stage('claim');
  }

  btn.addEventListener('click', function(){
    if(done) return;
    if(!running){
      running=true; t0=performance.now();
      btnLabel.textContent='STOP';
      btn.classList.add('is-live');
      raf=requestAnimationFrame(tick);
      return;
    }
    finish((performance.now()-t0)/1000, false);
  });

  var form=root.querySelector('[data-tmrg-form]');
  if(form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var email=(form.email.value||'').trim(), phone=(form.phone.value||'').trim();
    var err=root.querySelector('[data-tmrg-err]');
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ err.textContent='Please enter a valid email.'; err.hidden=false; return }
    if(phone.replace(/\D/g,'').length < 10){ err.textContent='Please enter a valid phone number.'; err.hidden=false; return }
    err.hidden=true;
    root.querySelector('[data-tmrg-claimbtn]').textContent='Claiming…';
    var tags=['newsletter','stop-the-clock','phone:'+phone.replace(/\s+/g,'')];
    if(form.sms && form.sms.checked) tags.push('sms-optin');
    var fd=new FormData();
    fd.append('form_type','customer'); fd.append('utf8','✓');
    fd.append('contact[email]',email); fd.append('contact[tags]',tags.join(','));
    fetch('/contact',{method:'POST',body:fd}).catch(function(){});
    setTimeout(function(){ lsSet(LS_CLAIMED,'1'); stage('code'); },450);
  });

  var copyBtn=root.querySelector('[data-tmrg-copy]');
  if(copyBtn) copyBtn.addEventListener('click', function(){
    var c=root.querySelector('[data-tmrg-code]').textContent;
    if(navigator.clipboard) navigator.clipboard.writeText(c).then(function(){
      copyBtn.classList.add('is-copied');
      copyBtn.querySelector('small').textContent='copied';
    });
  });

  var open=false, tab=root.querySelector('[data-tmrg-tab]');
  function restore(){
    var saved=lsGet(LS_RESULT);
    if(!saved) return;
    try{
      var r=JSON.parse(saved); done=true;
      display.textContent=fmt(parseFloat(r.t));
      paintResult(r.won, r.t, r.to);
      stage(lsGet(LS_CLAIMED)?'code':'claim');
    }catch(e){}
  }
  function show(){
    if(open) return; open=true;
    root.classList.add('is-open'); root.setAttribute('aria-hidden','false');
    if(tab) tab.hidden=true;
    restore();
  }
  function hide(){
    open=false; root.classList.remove('is-open'); root.setAttribute('aria-hidden','true');
    if(tab) tab.hidden=false;
  }
  root.querySelectorAll('[data-tmrg-close]').forEach(function(el){ el.addEventListener('click', hide) });
  if(tab) tab.addEventListener('click', function(){ show(); });

  var isDesign=window.Shopify&&Shopify.designMode;
  if(isDesign){ show(); return; }

  if(lsGet(LS_SEEN)){
    if(tab) tab.hidden=false;
    return;
  }

  /* Auto-open ONCE, a few seconds after the visitor starts scrolling. */
  var timerStarted=false, fired=false;
  function armOnScroll(){
    if(timerStarted || fired) return;
    if((window.scrollY||window.pageYOffset||0) < 40) return;
    timerStarted=true;
    window.removeEventListener('scroll', armOnScroll);
    setTimeout(function(){
      if(fired) return; fired=true;
      lsSet(LS_SEEN,'1');
      show();
    }, delay);
  }
  window.addEventListener('scroll', armOnScroll, { passive:true });
})();
